import React from 'react'
import styles from '@/pages/scss/Accessories.module.scss'
import { Box, styled, useMediaQuery } from '@mui/material'
import { Typography } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import Complete40 from '@evocolabs/icons/lib/Complete40'

const Line = styled('div')`
  width: 100%;
  height: 0;
  border: 0.5px solid ${theme.palette.grey[300]};
  margin-bottom: 48px;
`

const Tips = ({ tips }) => {
  const useMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Box className={styles.tipsWrapper}>
      <Typography
        variant={useMobile ? 'h3' : 'h2'}
        sx={{
          fontSize: useMobile ? 'none' : '32px',
          mb: useMobile ? '32px' : '50px',
          textAlign: useMobile ? 'center' : 'left'
        }}
      >
        Tips
      </Typography>
      {useMobile && <Line />}
      {tips.map((item) => (
        <Box className={styles.tips} key={item}>
          <Box sx={{ mr: '32px', height: '40px' }}>
            <Complete40 />
          </Box>
          <Typography variant={useMobile ? 'subh1' : 'h3'}>{item}</Typography>
        </Box>
      ))}
    </Box>
  )
}

export default Tips
